import React from "react";
import { Text } from "../../atoms/text/text";
import pillStyles from "../../molecules/channel-search/show-more-pill.module.css";
import styles from "./show-more-toggle.module.css";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * The Show More / Show Less control — a channel row's details (GR5) and a pack's collapsed logo grid
 * (GP12).
 */
export interface ShowMoreToggleProps {
  /** The collapsed state's wording. Absent, the control shows only its chevron. */
  moreLabel?: string;
  /** The expanded state's wording. Absent, the control shows only its chevron. */
  lessLabel?: string;
  /** `"link"` (default) is the inline text link; `"pill"` is the centred tonal pill between two
   *  rules that the search chips use (`16557:25133`). */
  variant?: "link" | "pill";
  /** Layout only. */
  className?: string;
}

function ShowMoreToggleImpl({
  moreLabel,
  lessLabel,
  variant = "link",
  className
}: ShowMoreToggleProps) {
  const pill = variant === "pill";
  const control = (
    <span
      className={[pill ? pillStyles.pill : styles.toggle, pill ? null : className].filter(Boolean).join(" ")}
    >
      <Text
        as="span"
        className={`${styles.label} ${styles.more}`}
        variant={pill ? "body-3" : "text-link-3"}
        weight={pill ? "medium" : undefined}
      >
        {moreLabel}
      </Text>
      <Text
        as="span"
        className={`${styles.label} ${styles.less}`}
        variant={pill ? "body-3" : "text-link-3"}
        weight={pill ? "medium" : undefined}
      >
        {lessLabel}
      </Text>
      <svg aria-hidden="true" className={styles.chevron} focusable="false" viewBox="0 0 16 16">
        <path
          d="M4 6.5 8 10.5 12 6.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    </span>
  );

  return pill ? (
    <span className={[pillStyles.pillRow, className].filter(Boolean).join(" ")}>{control}</span>
  ) : (
    control
  );
}
export const ShowMoreToggle = withSafeRender(ShowMoreToggleImpl, "ShowMoreToggle");

export default ShowMoreToggle;
